import { render } from "./BooGoHeroSection.vue?vue&type=template&id=b71bb66e&scoped=true"
import script from "./BooGoHeroSection.vue?vue&type=script&lang=js"
export * from "./BooGoHeroSection.vue?vue&type=script&lang=js"

import "./BooGoHeroSection.vue?vue&type=style&index=0&id=b71bb66e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b71bb66e"]])

export default __exports__